import subDays from 'date-fns/esm/subDays';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import columns from './columns';

const namespaced = true;

const state = {
  lessons: [],
  lessonsTags: [],
  searchTags: [],
  searchKeywords: '',
  count: 0,
  columns,
  currentPage: 0,
  dateRange: {
    start: subDays(new Date(), 30),
    end: subDays(new Date(), 1),
  },
  filters: {
    level: {
      max_quantum: 1,
      min_quantum: 0,
    },
    media_type: null,
  },
  lastRefreshDate: null,
  ordering: '-date_published',
  pageSize: 15,
  levels: [],
  availableFeatureGroups: [],
};

export default {
  namespaced,
  actions,
  getters,
  mutations,
  state,
};
